import script from "./MapComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MapComponent.vue?vue&type=script&setup=true&lang=js"

import "./MapComponent.vue?vue&type=style&index=0&id=49c5a3f3&lang=css"

const __exports__ = script;

export default __exports__